import type from './constants';

const initState = {
    updateDoctor: {},
    searchParams: {},
}

export default (state = initState, actions) => {
    switch(actions.type) {
        case type.UPDATE_DOCTOR:
            return {
                ...state,
                updateDoctor: {
                    ...actions.params
                }
            };
        case type.SAVE_SEARCH_PARAMS:
            return {
                ...state,
                searchParams: {
                    ...actions.params
                }
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/hospital/doctorInfo/store/reducer.js